import { render, staticRenderFns } from "./wantAsk.vue?vue&type=template&id=e2d7808a&scoped=true"
import script from "./wantAsk.vue?vue&type=script&lang=js"
export * from "./wantAsk.vue?vue&type=script&lang=js"
import style0 from "./wantAsk.vue?vue&type=style&index=0&id=e2d7808a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d7808a",
  null
  
)

export default component.exports